import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { bibtex } from './bibtexMode';
import { lightBibtexThemeExtension, darkBibtexThemeExtension } from './bibtexTheme';

/**
 * BibTeXEditor - A syntax-highlighted code editor for BibTeX entries
 *
 * Props:
 * - value: string - The BibTeX content
 * - onChange: function - Callback when content changes
 * - placeholder: string - Placeholder text
 * - darkMode: boolean - Whether to use dark theme
 * - height: string - Editor height (default: "200px")
 * - readOnly: boolean - Whether the editor is read-only
 * - className: string - Additional CSS classes
 */
function BibTeXEditor({
  value,
  onChange,
  placeholder = '',
  darkMode = false,
  height = '200px',
  readOnly = false,
  className = ''
}) {
  // Use custom BibTeX mode for better syntax highlighting
  const bibtexLanguage = bibtex();

  const handleChange = (val) => {
    if (onChange) {
      // Create a synthetic event object to match textarea onChange signature
      onChange({ target: { value: val } });
    }
  };

  // Combine language mode with theme extensions
  const extensions = [
    bibtexLanguage,
    ...(darkMode ? darkBibtexThemeExtension : lightBibtexThemeExtension)
  ];

  return (
    <div className={`bibtex-editor-wrapper ${className}`}>
      <CodeMirror
        value={value}
        height={height}
        placeholder={placeholder}
        extensions={extensions}
        onChange={handleChange}
        readOnly={readOnly}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLineGutter: true,
          highlightActiveLine: true,
          foldGutter: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: false,
          highlightSelectionMatches: false,
        }}
        style={{
          fontSize: '13px',
          border: darkMode ? '2px solid #555' : '2px solid #3498db',
          borderRadius: '4px',
        }}
      />
    </div>
  );
}

export default BibTeXEditor;
